import React, { Fragment } from "react";
import styled from "styled-components";
import developerLogo from "assets/icon-logo-developer.svg";
import Icon from "components/Icon";
import AppOpticsLogo from "components/svg/appoptics-logo.svg";
import { SUBSCRIPTION_MODE } from "../Billing/constants";
import { Alignment } from "../../components/Alignment";

const ModeName = styled.span`
  font-weight: bold;
  line-height: ${p =>
    p.small ? "inherit" : p.theme.ContractDetails.Logo.lineHeight};
`;

const LogoWrapper = styled.div`
  font-size: ${p =>
    p.logo && !p.small ? p.theme.ContractDetails.Logo.fontSize : "24px"};
  width: fit-content;
  align-content: center;
  color: ${p =>
    p.mode === SUBSCRIPTION_MODE.PRODUCTION ||
    p.mode === SUBSCRIPTION_MODE.TRIAL
      ? p.theme.ContractDetails.Heading.highlightColor
      : p.theme.ContractDetails.Heading.color};
`;

const LogoDescription = styled.div`
  font-size: ${p => p.theme.ContractDetails.ListHeading.fontSize};
  font-weight: ${p =>
    p.small ? "normal" : p.theme.ContractDetails.ListHeading.fontWeight};
  text-align: center;
  color: initial;
`;

const EditionLogo = ({ mode, label, logo, small }) => {
  const title =
    mode === SUBSCRIPTION_MODE.TRIAL ? SUBSCRIPTION_MODE.PRODUCTION : mode;

  const labelText = () => {
    switch (mode) {
      case SUBSCRIPTION_MODE.DEVELOPER:
        return "Limited Features";
      case SUBSCRIPTION_MODE.PRODUCTION:
        return "Full Features";
      case SUBSCRIPTION_MODE.TRIAL:
        return "Free 30-day Trial";
    }
  };

  const Logo = Icon(developerLogo);

  return (
    <Fragment>
      {mode === SUBSCRIPTION_MODE.DEVELOPER ? (
        <LogoWrapper mode={mode} logo={logo} small={small}>
          <ModeName small={small}>{title}</ModeName>Edition{logo && <Logo height={small && "30px"} />}
          {label && (
            <LogoDescription small={small}>{labelText()}</LogoDescription>
          )}
        </LogoWrapper>
      ) : (
        <Alignment height={"38px"} horizontal={"center"} vertical={"normal"}>
          <AppOpticsLogo />
        </Alignment>
      )}
    </Fragment>
  );
};

export default EditionLogo;
